// Resolved values of tokens.css (compact density) for code that needs real
// colour strings, e.g. canvas charts. tests/unit/tokenValues.test.ts keeps it in sync.
export const lightTokens: Record<string, string> = {
  'accent-bright': '#394eff',
  'action-accent-bg': '#2f3bd5',
  'action-accent-bg-hover': '#232ea0',
  'action-accent-fg': '#ffffff',
  'action-danger-bg': '#a21a1b',
  'action-danger-bg-hover': '#811213',
  'action-danger-fg': '#ffffff',
  'action-primary-bg': '#101b29',
  'action-primary-bg-active': '#050e19',
  'action-primary-bg-hover': '#222f3f',
  'action-primary-fg': '#ffffff',
  'action-secondary-bg': '#ffffff',
  'action-secondary-bg-active': '#e4ecf6',
  'action-secondary-bg-hover': '#f4f9ff',
  'action-secondary-border': '#e2ebf8',
  'action-secondary-fg': '#091524',
  'action-subtle-bg': 'transparent',
  'action-subtle-bg-active': '#dfe6f0',
  'action-subtle-bg-hover': '#e7edf5',
  'action-subtle-fg': '#233144',
  armada: '#007378',
  'border-accent': '#3c4ef9',
  'border-danger': '#c02c29',
  'border-default': '#e2ebf8',
  'border-strong': '#d7e2f0',
  'border-subtle': '#e8f0fa',
  'border-width': '1px',
  'border-width-strong': '1px',
  'chart-1': '#0a85a1',
  'chart-2': '#c56c21',
  'chart-3': '#6b4cae',
  'chart-4': '#b08505',
  'chart-5': '#bc4891',
  'chart-6': '#218a45',
  'chart-7': '#195daa',
  'chart-8': '#c92f33',
  'chart-axis': '#556579',
  'chart-grid': '#dfe6f0',
  'chart-heat-high': '#232ea0',
  'chart-heat-low': '#dde6ff',
  'code-builtin': '#006364',
  'code-fn': '#315c92',
  'code-keyword': '#5c4c87',
  'code-number': '#804d18',
  'code-string': '#2b5f39',
  'content-accent': '#2f3bd5',
  'content-danger': '#a21a1b',
  'content-decorative': '#617083',
  'content-disabled': '#8c99aa',
  'content-inverse': '#ffffff',
  'content-max': '85rem',
  'content-muted': '#405063',
  'content-placeholder': '#506074',
  'content-primary': '#00030e',
  'content-secondary': '#233144',
  'content-success': '#1d6839',
  'content-warning': '#744c00',
  'control-height-lg': '2.25rem',
  'control-height-md': '1.875rem',
  'control-height-sm': '1.625rem',
  'control-height-xs': '1.375rem',
  'display-scale': '1',
  'display-tracking': '-0.022em',
  'display-weight': '600',
  'drawer-form': '30rem',
  'drawer-wide': '45rem',
  'duration-fast': '180ms',
  'duration-instant': '100ms',
  'duration-live': '2400ms',
  'duration-normal': '260ms',
  'duration-slow': '380ms',
  'ease-in': 'cubic-bezier(0.32, 0, 0.67, 0)',
  'ease-in-out': 'cubic-bezier(0.65, 0, 0.35, 1)',
  'ease-out': 'cubic-bezier(0.22, 1, 0.36, 1)',
  'ease-spring': 'cubic-bezier(0.34, 1.4, 0.64, 1)',
  'focus-ring': '#3c4ef9',
  'focus-ring-offset': '#ffffff',
  'font-display':
    "'Inter Tight', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  'font-mono':
    "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
  'font-num': "'Geist Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
  'font-prose':
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  'font-sans':
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  'font-tag': "'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
  'header-height': '2.75rem',
  'impact-high': '#c02c29',
  'impact-low': '#99a6b7',
  'impact-medium': '#bb7e00',
  'impact-track': '#d3dde9',
  'leading-normal': '1.5',
  'leading-relaxed': '1.6',
  'leading-snug': '1.35',
  'leading-tight': '1.2',
  'list-row-height': '3.4375rem',
  'mark-danger': '#dc5e55',
  'mark-search': '#e2aa00',
  'mark-success': '#579e6c',
  'mark-warning': '#d79f4c',
  'motion-lift': '2px',
  'motion-press': '0.97',
  'motion-unfold': '0.88',
  'nav-row-height': '1.875rem',
  'nav-width': '16rem',
  'nav-width-collapsed': 'calc(0.75rem * 2 + 1.75rem)',
  'pill-off-bg': 'transparent',
  'pill-off-border': '#dde2e4',
  'pill-off-fg': '#6a7376',
  'pill-on-bg': '#edf2ff',
  'pill-on-border': '#bfd0ff',
  'pill-on-fg': '#232ea0',
  'radius-check': '2px',
  'radius-chip': '2px',
  'radius-control': '4px',
  'radius-full': '999px',
  'radius-surface': '8px',
  'radius-track': 'calc(4px + 2px)',
  'row-height': '2.375rem',
  scrim: 'rgb(13 25 28 / 0.45)',
  'shadow-color': '13 25 28',
  'shadow-modal':
    '0 2px 4px -2px rgb(13 25 28 / 0.12), 0 24px 48px -20px rgb(13 25 28 / 0.24)',
  'shadow-none': 'none',
  'shadow-popover':
    '0 1px 2px -1px rgb(13 25 28 / 0.1), 0 8px 24px -10px rgb(13 25 28 / 0.18)',
  'space-0': '0',
  'space-1': '0.125rem',
  'space-10': '2.5rem',
  'space-11': '3rem',
  'space-2': '0.25rem',
  'space-3': '0.375rem',
  'space-4': '0.5rem',
  'space-5': '0.75rem',
  'space-6': '1rem',
  'space-7': '1.25rem',
  'space-8': '1.5rem',
  'space-9': '2rem',
  'space-px': '1px',
  'status-danger-bg': '#ffefed',
  'status-danger-border': '#ffbab1',
  'status-danger-fg': '#811213',
  'status-info-bg': '#edf2ff',
  'status-info-border': '#bfd0ff',
  'status-info-fg': '#232ea0',
  'status-neutral-bg': '#eff3f9',
  'status-neutral-border': '#e2ebf8',
  'status-neutral-fg': '#233144',
  'status-success-bg': '#e8f8ec',
  'status-success-border': '#aae1b7',
  'status-success-fg': '#104f29',
  'status-warning-bg': '#fff3e4',
  'status-warning-border': '#fbcb88',
  'status-warning-fg': '#744c00',
  'surface-active': '#dfe6f0',
  'surface-canvas': '#fcfdfe',
  'surface-default': '#f7fafd',
  'surface-disabled': '#e7edf5',
  'surface-hover': '#e7edf5',
  'surface-inverse': '#101b29',
  'surface-nav': '#f2f7fd',
  'surface-raised': '#ffffff',
  'surface-selected': '#edf2ff',
  'surface-sunken': '#eff3f9',
  'tag-case': 'uppercase',
  'tag-size': '0.6875rem',
  'tag-tracking': '0.04em',
  'tag-weight': '500',
  'text-2xl': '1.375rem',
  'text-2xs': '0.6875rem',
  'text-lg': '1rem',
  'text-md': '0.875rem',
  'text-sm': '0.8125rem',
  'text-xl': '1.125rem',
  'text-xs': '0.75rem',
  'title-weight': '500',
  'tooltip-bg': '#101b29',
  'tooltip-border': 'transparent',
  'tooltip-fg': '#ffffff',
  'tracking-normal': '0',
  'tracking-tight': '-0.011em',
  'tracking-wide': '0.01em',
  'weight-medium': '500',
  'weight-regular': '400',
  'weight-semibold': '600',
  'z-base': '0',
  'z-dock': '150',
  'z-dropdown': '1100',
  'z-modal': '1000',
  'z-overlay': '1000',
  'z-sticky': '100',
  'z-toast': '1200',
  'z-tooltip': '1300',
};

export const darkTokens: Record<string, string> = {
  ...lightTokens,
  'accent-bright': '#6e8eff',
  'action-accent-bg': '#3c4ef9',
  'action-accent-bg-hover': '#607fff',
  'action-accent-fg': '#ffffff',
  'action-danger-bg': '#c02c29',
  'action-danger-bg-hover': '#a21a1b',
  'action-danger-fg': '#ffffff',
  'action-primary-bg': '#f0f3f4',
  'action-primary-bg-active': '#dde2e4',
  'action-primary-bg-hover': '#ffffff',
  'action-primary-fg': '#090e10',
  'action-secondary-bg': '#1a2023',
  'action-secondary-bg-active': '#070c0e',
  'action-secondary-bg-hover': '#232a2d',
  'action-secondary-border': '#272e30',
  'action-secondary-fg': '#eff2f4',
  'action-subtle-bg': 'transparent',
  'action-subtle-bg-active': '#232a2d',
  'action-subtle-bg-hover': '#1a2023',
  'action-subtle-fg': '#d7dcdd',
  armada: '#4fb7bc',
  'border-accent': '#3c4ef9',
  'border-danger': '#c02c29',
  'border-default': '#272e30',
  'border-strong': '#333b3d',
  'border-subtle': '#1b2224',
  'border-width': '1px',
  'border-width-strong': '1px',
  'chart-1': '#309ab7',
  'chart-2': '#d67523',
  'chart-3': '#9379d7',
  'chart-4': '#b68b16',
  'chart-5': '#d168a7',
  'chart-6': '#48a260',
  'chart-7': '#4087de',
  'chart-8': '#d74745',
  'chart-axis': '#b8bfc1',
  'chart-grid': '#1e2528',
  'chart-heat-high': '#97b0ff',
  'chart-heat-low': '#0f1842',
  'code-builtin': '#7dcece',
  'code-fn': '#97c1f7',
  'code-keyword': '#c1b3ef',
  'code-number': '#e9b588',
  'code-string': '#99cda3',
  'content-accent': '#97b0ff',
  'content-danger': '#ffbab1',
  'content-decorative': '#9fa6a8',
  'content-disabled': '#5c6568',
  'content-inverse': '#090e10',
  'content-max': '85rem',
  'content-muted': '#b8bfc1',
  'content-placeholder': '#b8bfc1',
  'content-primary': '#eff2f4',
  'content-secondary': '#d7dcdd',
  'content-success': '#aae1b7',
  'content-warning': '#fbcb88',
  'control-height-lg': '2.25rem',
  'control-height-md': '1.875rem',
  'control-height-sm': '1.625rem',
  'control-height-xs': '1.375rem',
  'display-scale': '1',
  'display-tracking': '-0.022em',
  'display-weight': '600',
  'drawer-form': '30rem',
  'drawer-wide': '45rem',
  'duration-fast': '180ms',
  'duration-instant': '100ms',
  'duration-live': '2400ms',
  'duration-normal': '260ms',
  'duration-slow': '380ms',
  'ease-in': 'cubic-bezier(0.32, 0, 0.67, 0)',
  'ease-in-out': 'cubic-bezier(0.65, 0, 0.35, 1)',
  'ease-out': 'cubic-bezier(0.22, 1, 0.36, 1)',
  'ease-spring': 'cubic-bezier(0.34, 1.4, 0.64, 1)',
  'focus-ring': '#607fff',
  'focus-ring-offset': '#0f1517',
  'font-display':
    "'Inter Tight', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  'font-mono':
    "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
  'font-num': "'Geist Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
  'font-prose':
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  'font-sans':
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  'font-tag': "'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
  'header-height': '2.75rem',
  'impact-high': '#dc5e55',
  'impact-low': '#798285',
  'impact-medium': '#d79f4c',
  'impact-track': '#282f32',
  'leading-normal': '1.5',
  'leading-relaxed': '1.6',
  'leading-snug': '1.35',
  'leading-tight': '1.2',
  'list-row-height': '3.4375rem',
  'mark-danger': '#dc5e55',
  'mark-search': '#f0c234',
  'mark-success': '#579e6c',
  'mark-warning': '#d79f4c',
  'motion-lift': '2px',
  'motion-press': '0.97',
  'motion-unfold': '0.88',
  'nav-row-height': '1.875rem',
  'nav-width': '16rem',
  'nav-width-collapsed': 'calc(0.75rem * 2 + 1.75rem)',
  'pill-off-bg': 'transparent',
  'pill-off-border': '#282f32',
  'pill-off-fg': '#798285',
  'pill-on-bg': '#0f1842',
  'pill-on-border': '#232ea0',
  'pill-on-fg': '#bfd0ff',
  'radius-check': '2px',
  'radius-chip': '2px',
  'radius-control': '4px',
  'radius-full': '999px',
  'radius-surface': '8px',
  'radius-track': 'calc(4px + 2px)',
  'row-height': '2.375rem',
  scrim: 'rgb(0 0 0 / 0.62)',
  'shadow-color': '0 0 0',
  'shadow-modal':
    '0 2px 4px -2px rgb(0 0 0 / 0.12), 0 24px 48px -20px rgb(0 0 0 / 0.24)',
  'shadow-popover':
    '0 1px 2px -1px rgb(0 0 0 / 0.1), 0 8px 24px -10px rgb(0 0 0 / 0.18)',
  'shadow-none': 'none',
  'space-0': '0',
  'space-1': '0.125rem',
  'space-10': '2.5rem',
  'space-11': '3rem',
  'space-2': '0.25rem',
  'space-3': '0.375rem',
  'space-4': '0.5rem',
  'space-5': '0.75rem',
  'space-6': '1rem',
  'space-7': '1.25rem',
  'space-8': '1.5rem',
  'space-9': '2rem',
  'space-px': '1px',
  'status-danger-bg': '#380b09',
  'status-danger-border': '#5a1110',
  'status-danger-fg': '#ffbab1',
  'status-info-bg': '#0f1842',
  'status-info-border': '#192571',
  'status-info-fg': '#bfd0ff',
  'status-neutral-bg': '#1a2023',
  'status-neutral-border': '#1b2224',
  'status-neutral-fg': '#d7dcdd',
  'status-success-bg': '#082311',
  'status-success-border': '#0d3a1e',
  'status-success-fg': '#aae1b7',
  'status-warning-bg': '#2b1900',
  'status-warning-border': '#442a00',
  'status-warning-fg': '#fbcb88',
  'surface-active': '#232a2d',
  'surface-canvas': '#030506',
  'surface-default': '#0f1517',
  'surface-disabled': '#070c0e',
  'surface-hover': '#1a2023',
  'surface-inverse': '#f0f3f4',
  'surface-nav': '#070c0e',
  'surface-raised': '#1a2023',
  'surface-selected': '#0f1842',
  'surface-sunken': '#070c0e',
  'tag-case': 'uppercase',
  'tag-size': '0.6875rem',
  'tag-tracking': '0.04em',
  'tag-weight': '500',
  'text-2xl': '1.375rem',
  'text-2xs': '0.6875rem',
  'text-lg': '1rem',
  'text-md': '0.875rem',
  'text-sm': '0.8125rem',
  'text-xl': '1.125rem',
  'text-xs': '0.75rem',
  'title-weight': '500',
  'tooltip-bg': '#1a2023',
  'tooltip-border': '#272e30',
  'tracking-normal': '0',
  'tracking-tight': '-0.011em',
  'tracking-wide': '0.01em',
  'weight-medium': '500',
  'weight-regular': '400',
  'weight-semibold': '600',
  'z-base': '0',
  'z-dock': '150',
  'z-dropdown': '1100',
  'z-modal': '1000',
  'z-overlay': '1000',
  'z-sticky': '100',
  'z-toast': '1200',
  'z-tooltip': '1300',
  'tooltip-fg': '#eff2f4',
};
